import React from 'react';

import { node, oneOf, string } from 'prop-types';

import { faSchoolFlag } from '@fortawesome/pro-regular-svg-icons/faSchoolFlag';
import { faSuitcase } from '@fortawesome/pro-regular-svg-icons/faSuitcase';
import { faUser } from '@fortawesome/pro-solid-svg-icons/faUser';

import MuiAvatar from '@mui/material/Avatar';

import FontAwesomeIcon from 'components/Common/FontAwesomeIcon';

const sizes = {
  xxl: {
    width: 64,
    height: 64,
    icon: '2xl',
  },
  xl: {
    width: 56,
    height: 56,
    icon: 'xl',
  },
  lg: {
    width: 48,
    height: 48,
    icon: 'lg',
  },
  md: {
    width: 40,
    height: 40,
    icon: null,
  },
  sm: {
    width: 32,
    height: 32,
    icon: 'sm',
  },
  xs: {
    width: 24,
    height: 24,
    icon: 'xs',
  },
  xxs: {
    width: 16,
    height: 16,
    icon: '2xs',
  },
};

const Avatar = ({ alt, children, className, fallback, size, src, variant }) => {
  const renderFallback = label => {
    if (children) {
      return children;
    }

    switch (fallback) {
      case 'person':
        return (
          <FontAwesomeIcon alt={label} icon={faUser} size={sizes[size].icon} />
        );
      case 'school':
        return (
          <FontAwesomeIcon
            alt={label}
            icon={faSchoolFlag}
            size={sizes[size].icon}
          />
        );
      case 'employer':
        return (
          <FontAwesomeIcon
            alt={label}
            icon={faSuitcase}
            size={sizes[size].icon}
          />
        );
      default:
        return null;
    }
  };
  return (
    <MuiAvatar
      alt={alt}
      className={className}
      src={src}
      sx={sizes[size]}
      variant={variant}
    >
      {renderFallback(alt)}
    </MuiAvatar>
  );
};

Avatar.defaultProps = {
  alt: '',
  children: undefined,
  className: undefined,
  fallback: 'person',
  size: 'md',
  src: '',
  variant: 'circular',
};

Avatar.propTypes = {
  alt: string,
  children: node,
  className: string,
  fallback: oneOf(['person', 'school', 'employer']),
  size: oneOf(['xxs', 'xs', 'sm', 'md', 'lg', 'xl', 'xxl']),
  src: string,
  variant: oneOf(['circular', 'rounded', 'square']),
};

export default Avatar;
